<div *ngFor="let user of userList | slice:0:avatarMax; trackBy:getUserId" class="app-avatar"
  [ngClass]="{ 'animated zoomInSeq': enableAnimation }" [style.backgroundColor]="user.avatarColor"
  [style.backgroundSize]="'cover'">
  <span #userPopover fwPopoverPosition="above">
    <img *ngIf="user.hasValidImage" [src]="user.avatar" (error)="onAvatarImageError(user)">
    {{ !user.avatar || !user.hasValidImage ? user.initials : '' }}
  </span>
  <fw-popover *ngIf="enablePopover" [trigger]="userPopover" position="below" action="mouseenter">
    <div class="padding-15">{{ user.info }}<br>{{ user.email }}</div>
  </fw-popover>
</div>

<ng-container *ngIf="userList.length > avatarMax && userList.length !== 1">
  <div style="padding: 5px 0; margin: 0;" class="app-avatar app-avatar-more clickable" #extraPopover>
    +{{ userList.length - avatarMax }}
  </div>

  <fw-popover [trigger]="extraPopover" position="above" action="mouseenter">
    <div class="padding-15" style="max-height: 300px; overflow-y: auto; overflow-x: hidden;">
      <div *ngFor="let user of extraUsers; index as userIndex; trackBy:getUserId"
        [attr.style]="userIndex + 1 !== extraUsers.length ? 'margin: 0 10px 10px 0' : 'margin: 0 10px 0 0'">
        {{ user.info }}<br>{{ user.email }}
      </div>
    </div>
  </fw-popover>
</ng-container>
